import { ABMGenerico } from "src/general_components/ABMGenerico";
import RestriccionesPorPerfil from "src/general_components/PermisosPerfiles";
import IconButton from '@mui/material/IconButton'; // Botón para íconos con funcionalidad de clic
import Tooltip from '@mui/material/Tooltip'; // Para mostrar el tooltip sobre el ícono
import { Grid } from "@mui/material";
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import { SimpleDialogComponent } from "src/general_components/SimpleDialogComponent";
import { useState, useEffect } from "react";
import { getRolesMenu, getMenu, postRolesMenu, getRolesMenuFuncionalidad, postRolMenuFuncionalidad } from 'src/general_helpers/Menu';
import { SnackbarMessenger } from "src/general_components/SnackbarMessenger";
import esArray from "src/general_components/functionEsArray";

export const Roles = () => {
    const modelo = "roles";
    const [modalState, setModalState] = useState(false);
    const [menu_list, setMenuList] = useState([]);
    const [roles_menu, setRolesMenu] = useState([]);
    const [id_roles, setIdROles] = useState(false);
    const [insertData, setInsertData] = useState(false);
    const [datos_insert, setDatosInsert] = useState([]);
    const [message, setMessage] = useState("");
    const [severity, setSeverity] = useState("success");
    const [snackbarVisible, setSnackbarVisible] = useState(false);
    const [roles_menu_funcionalidad, setRolesMenuFuncionalidad] = useState([]);

    let dialogChild = <RestriccionesPorPerfil menu={menu_list} roles_menu={roles_menu} roles_menu_funcionalidad={roles_menu_funcionalidad} id_roles={id_roles} setDatosInsert={setDatosInsert}></RestriccionesPorPerfil>

    /**********************************************************************
        🌟 Obtiene los datos de permisos de un rol y los envía al componente 
        RestriccionesPorPerfil para mostrarlos en la tabla de permisos del 
        rol seleccionado en el modal.
    **********************************************************************/
    const handleButtonClick = async (rowData) => {
        setIdROles(rowData.id);
        await obtenerDatosPermisos(rowData.id);
        toggleModal();
    };

    /**********************************************************************
        🌟 Cambia el estado del modal. Si el modal está abierto, 
        restablece las variables `rolesMenuFuncionalidad` y `rolesMenu` 
        a sus valores iniciales antes de cerrar el modal.
    **********************************************************************/
    const toggleModal = () => {
        if (!insertData && modalState) {
            setRolesMenuFuncionalidad([]);
            setRolesMenu([]);
        }

        setModalState(!modalState);
    };

    /**********************************************************************
        🌟 Obtiene los datos de los permisos asociados a un rol específico.  
        Consulta los menús y las funcionalidades asociadas al rol, y actualiza 
        el estado con los datos procesados.
    **********************************************************************/
    const obtenerDatosPermisos = async (rol) => {
        let response_roles_menu = await getRolesMenu(rol);
        let response_roles_menu_funcionalidad = await getRolesMenuFuncionalidad(rol);
        if (response_roles_menu.length > 0) {
            response_roles_menu = response_roles_menu[0].relations?.roles_menu
                ? response_roles_menu[0].relations.roles_menu
                : [];
            setRolesMenu(response_roles_menu);
        }

        if (response_roles_menu_funcionalidad.length > 0) {
            response_roles_menu_funcionalidad = response_roles_menu_funcionalidad
                ? esArray(response_roles_menu_funcionalidad)
                : [];
            setRolesMenuFuncionalidad(response_roles_menu_funcionalidad);
        }
    };

    /**********************************************************************
        🌟 Obtiene la lista de menús a través de la función `getMenu()`, 
        transforma la estructura de los datos usando `transformar_menu_list()`, 
        y luego actualiza el estado `menuList` con la lista de menús transformada.
    **********************************************************************/
    const obtenerMenus = async () => {
        const response_menu_list = transformar_menu_list(await getMenu());
        setMenuList(response_menu_list);
    };

    /**********************************************************************
        🌟 Transforma la lista de menús, mapeando cada ítem para ajustar 
        su estructura: asigna la jerarquía a `level`, usa `detalle` como `name`,
        obtiene el nombre del módulo desde `relations.modulos.nombre`, 
        y conserva el objeto original para referencia futura.
    **********************************************************************/
    const transformar_menu_list = (data) => {
        return data.map(item => ({
            level: item.jerarquia, // Asignar la jerarquía a level
            name: item.detalle, // Usar detalle como name
            module: item.relations?.modulos?.nombre || "", // Obtener el nombre del módulo desde relations.modulos.nombre
            ...item, // Guardar el objeto original por si es necesario acceder a más datos
        }));
    };


    /**********************************************************************
        🌟 Define una columna adicional para la tabla de datos con el campo 
        "columna_extra_1", que muestra un ícono de módulo y un tooltip 
        para administrar permisos. Al hacer clic en el ícono, se ejecuta 
        `handleButtonClick` con la fila seleccionada como parámetro.
    **********************************************************************/
    const columnasAdicional = [{
        field: "columna_extra_1",
        headerName: "Permisos",
        flex: 1,
        headerAlign: "center",
        renderCell: (params) => (
            <Grid style={{ alignItems: 'center', textAlign: 'center', margin: 'auto' }}>
                <Tooltip title="Administrar Permisos">
                    <IconButton onClick={() => handleButtonClick(params.row)}>
                        <ViewModuleIcon />
                    </IconButton>
                </Tooltip>
            </Grid>
        )
    }];

    /**********************************************************************
        🌟 Cambia el valor de `insertData` entre verdadero y falso 
        cada vez que se llama, alternando el estado de la variable 
        para controlar algún comportamiento de la interfaz o lógica.
    **********************************************************************/
    const confirmar = () => {
        setInsertData(!insertData);
    };

    /**********************************************************************
        🌟 Utiliza el hook `useEffect` para ejecutar la función `fetchMenus` 
        cuando el componente se monta. Esta función asíncrona obtiene 
        los menús llamando a `obtenerMenus`. Si ocurre algún error durante 
        la obtención de los menús, se muestra un mensaje de error en la consola.
    **********************************************************************/
    useEffect(() => {
        const fetchMenus = async () => {
            try {
                await obtenerMenus();
            } catch (error) {
                console.error("Error fetching menus:", error);
            }
        };
        fetchMenus();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**********************************************************************
        🌟 Utiliza el hook `useEffect` para ejecutar la función `fetchInsertRolesMenu` 
        cada vez que `insertData` cambie. Esta función realiza un proceso asíncrono 
        que transforma y procesa los datos relacionados con roles y menús, 
        actualiza el estado de la interfaz, y realiza las inserciones necesarias 
        utilizando `postRolMenuFuncionalidad` y `postRolesMenu`. Si todo es exitoso, 
        muestra un mensaje de éxito en un snackbar y limpia los datos relacionados 
        con roles y menús.
    **********************************************************************/
    useEffect(() => {
        const fetchInsertRolesMenu = async () => {
            try {
                if (insertData) {
                    const datos = transformarEstructura(datos_insert);
                    const data_insert_final = transformData(datos);
                    const datos_rolMenuFuncionalidad = processFunctionalities(datos, filterMenuFuncionalidad(menu_list), roles_menu_funcionalidad);
                    await postRolMenuFuncionalidad(datos_rolMenuFuncionalidad);
                    await postRolesMenu(data_insert_final);
                    setMessage("Proceso finalizado correctamente!!!");
                    setSeverity("success");
                    setSnackbarVisible(true);
                    setRolesMenuFuncionalidad([]);
                    setRolesMenu([]);
                    confirmar();
                }
            } catch (error) {
                console.error("Error fetching menus:", error);
            }
        };
        fetchInsertRolesMenu();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [insertData]); // No need to include setDatosInsert

    /**********************************************************************
        🌟 Transforma la estructura de los datos de entrada, moviendo los elementos 
        anidados en "items" al primer nivel de la estructura y manteniendo los 
        otros datos originales. El resultado es una nueva estructura plana.
    **********************************************************************/
    function transformarEstructura(data) {
        const result = {};

        // Iteramos sobre las claves principales de la estructura
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                const item = data[key];

                // Si tiene "items", los pasamos al primer nivel
                if (item.items) {
                    // Movemos los items al primer nivel
                    for (const subKey in item.items) {
                        if (item.items.hasOwnProperty(subKey)) {
                            result[subKey] = item.items[subKey];
                        }
                    }
                    // Eliminamos la propiedad "items"
                    delete item.items;
                }

                // Añadimos el objeto actualizado al resultado
                result[key] = item;
            }
        }

        return result;
    }

    /**********************************************************************
        🌟 Transforma los datos de entrada en un nuevo formato, asegurando que 
        cada entrada tenga los campos necesarios, como `id_menu`, `id_roles`, 
        y valores constantes para `id_owner` y `id_menu_acciones_tipo`. 
    **********************************************************************/
    function transformData(inputData) {
        const transformedArray = [];
        const idOwner = "29"; // Fijar el valor constante de id_owner
        const idMenuAccionesTipo = "1"; // Fijar el valor constante de id_menu_acciones_tipo

        for (const key in inputData) {
            transformedArray.push({
                id_menu: inputData[key].id_menu,
                id_roles: inputData[key].id_roles,
                id_menu_acciones_tipo: inputData[key].activo ? idMenuAccionesTipo : "2",
                id_owner: idOwner,
                id: inputData[key].id,
            });
        }
        return transformedArray;
    }

    /**********************************************************************
        🌟 Filtra los elementos de `menu_list` que contienen una propiedad 
        `menu_funcionalidad` en sus relaciones, y luego crea una nueva lista 
        con objetos que contienen la relación entre `id_menu`, `id_menu_funcionalidad`, 
        y `id_funcionalidad`.
    **********************************************************************/
    const filterMenuFuncionalidad = (array) => {
        return array
            .filter(item => item.relations && item.relations.menu_funcionalidad) // Filtra los objetos con el array 'menu_funcionalidad'
            .flatMap(item =>
                esArray(item.relations.menu_funcionalidad).map(menu => ({
                    id_menu: item.id,
                    id_menu_funcionalidad: menu.id, // Crea un objeto por cada 'menu_funcionalidad'
                    id_funcionalidad: menu.id_funcionalidades,
                }))
            );
    };

    /**********************************************************************
        🌟 Procesa y combina los datos de funcionalidades, fusionando las funcionalidades 
        de los datos proporcionados en `datos1`, `datos2` y `datos3`, respetando 
        las relaciones de `id_funcionalidad` y `id_menu`, y generando una estructura 
        final que incluye datos adicionales si están disponibles en `datos3`.
    **********************************************************************/
    function processFunctionalities(datos1, datos2, datos3 = []) {
        // Paso 1: Extraer id_funcionalidad de datos1 y preparar datos para mezclar
        const datos1Array = Object.entries(datos1).flatMap(([key, value]) => {
            return Object.keys(value)
                .filter(prop => !isNaN(Number(prop))) // Filtrar las propiedades numéricas
                .map(id_funcionalidad => ({
                    id_funcionalidad,
                    id_menu: value.id_menu,
                    id_roles: value.id_roles,
                    activo: value[id_funcionalidad] ? "1" : "0"
                }));
        });

        // Paso 2: Mechar datos1 con datos2 por id_funcionalidad e id_menu
        const mergedData = datos2.flatMap(d2 => {
            const match = datos1Array.find(d1 => d1.id_funcionalidad === d2.id_funcionalidad && d1.id_menu === d2.id_menu);
            if (match) {
                return {
                    id_menu: d2.id_menu,
                    id_menu_funcionalidad: d2.id_menu_funcionalidad,
                    id_funcionalidad: d2.id_funcionalidad,
                    id_roles: match.id_roles,
                    activo: match.activo
                };
            }
            return [];
        });

        // Paso 3: Comparar con datos3 si está presente
        const finalData = mergedData.map(item => {
            if (datos3.length > 0) {
                const matchByMenuAndFuncionalidad = datos3.find(d3 => d3.id_menu === item.id_menu && d3.id_funcionalidad === item.id_funcionalidad);
                const matchByMenuFuncionalidadId = datos3.find(d3 => d3.id_menu_funcionalidad === item.id_menu_funcionalidad);

                if (matchByMenuAndFuncionalidad) {
                    return { ...item, id: matchByMenuAndFuncionalidad.id };
                } else if (matchByMenuFuncionalidadId) {
                    return { ...item, id: matchByMenuFuncionalidadId.id };
                }
            }
            return item;
        });

        return finalData;
    }


    return (
        <>
            {/* Componente ABMGenerico para administrar el modelo 'Roles', con columnas adicionales */}
            <ABMGenerico modelo={modelo} titulo={"Roles"} columnasAdicional={columnasAdicional} />
    
            {/* Diálogo SimpleDialogComponent para administrar los permisos, 
                incluye botones para enviar y cancelar */}
            <SimpleDialogComponent
                open={modalState} // Determina si el diálogo está abierto
                modalName={"Administrador de Permisos"} // Título del diálogo
                child={dialogChild} // Contenido del diálogo
                handleClose={toggleModal} // Función para cerrar el modal
                buttonEnviar={true} // Muestra el botón "Enviar"
                buttonCancelar={true} // Muestra el botón "Cancelar"
                maxWidth="lg" // Establece el tamaño máximo del modal
                setPushData={confirmar} // Función que se ejecuta al confirmar los cambios
            />
    
            {/* Componente SnackbarMessenger para mostrar mensajes de estado */}
            <SnackbarMessenger
                open={snackbarVisible} // Controla si el Snackbar está visible
                message={message} // Mensaje a mostrar en el Snackbar
                severity={severity} // Gravedad del mensaje (ej. "success", "error")
                close={() => {
                    setSnackbarVisible(false); // Función para cerrar el Snackbar
                }}
            />
        </>
    );
    
};
